module.exports = __webpack_public_path__ + "static/media/Calendar 3.22a4ca3a.svg";